import { render, staticRenderFns } from "./expenseStandards.vue?vue&type=template&id=111b487d"
import script from "./expenseStandards.vue?vue&type=script&lang=js"
export * from "./expenseStandards.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports